import { AgGridTable, ErrorBoundary } from '@circuitry-ai/doc-ui';

const AgGridTableWithInlineLoading = (props: any) => {
  const { inlineLoading, ...restProps } = props;
  return <AgGridTable {...restProps} isLoading={inlineLoading} />;
};

const ErrorBoundAgGridTable = ErrorBoundary(AgGridTableWithInlineLoading);

const canonicalizeValue = (val: any) => {
  if (Array.isArray(val)) {
    return [...val].sort((a, b) => `${a}`.localeCompare(`${b}`));
  }
  return val;
};

const makeStableRequestKey = (body: any) => {
  const filters = Array.isArray(body?.filters) ? body.filters : [];
  const normalizedFilters = filters.map((f: any) => {
    const field = Object.keys(f).find((k) => k !== 'condition');
    const value = field ? canonicalizeValue(f[field]) : undefined;
    return { field: field || '', condition: f?.condition || '', value };
  }).sort((a: any, b: any) => {
    if (a.field !== b.field) return a.field.localeCompare(b.field);
    if (a.condition !== b.condition) return a.condition.localeCompare(b.condition);
    return JSON.stringify(a.value).localeCompare(JSON.stringify(b.value));
  });

  const sorting = body?.sorting ? { field: body.sorting.field, order: body.sorting.order } : undefined;
  const pagination = body?.pagination
    ? { page: body.pagination.page, per_page: body.pagination.per_page }
    : undefined;

  return JSON.stringify({ pagination, filters: normalizedFilters, sorting });
};

export { ErrorBoundAgGridTable, makeStableRequestKey };
export { DateFilterComponent, CustomDateFilter } from '@circuitry-ai/doc-ui';
